export default "__VITE_PUBLIC_ASSET__0980a05e__"